import type { RouteObject } from "react-router-dom";

export const mobileMessagingRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Mobile Messaging" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { MobileMessagingDashboard } = await import("./dashboard");
          return { Component: MobileMessagingDashboard };
        },
      },
    ],
  },
];
